import styled from "styled-components";

import { getIssueContent, IssuesListProps } from "./getIssueContent";

type IssueBadgeProps = {
  issue: keyof IssuesListProps;
  urgent?: boolean;
};

const Badge = styled.span<{ urgent?: boolean }>`
  border-color: ${({ urgent }) =>
    urgent ? "var(--red-500)" : "rgba(248, 63, 35, 0.50)"};
  background-color: ${({ urgent }) =>
    urgent ? "var(--red-100)" : "var(--base-0)"};
  font-weight: 500;
  padding: 5px 8px;
  line-height: 1;
`;

const IssueBadge = ({ issue, urgent }: IssueBadgeProps) => {
  const { emoji, title } = getIssueContent({ issue });

  return (
    <Badge urgent={urgent} className="badge badge--outline red-700 rounded mr2">
      {emoji} {title}
    </Badge>
  );
};

export default IssueBadge;
